import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';

import { adminApi } from './adminApi';

const AdminContext = createContext(null);

/** Admin logado (GET /admin/me). Sem sessao valida, chama onMissingSession. */
export function AdminProvider({ children, onMissingSession }) {
  const [admin, setAdmin] = useState(null);

  useEffect(() => {
    let active = true;
    adminApi
      .me()
      .then(({ admin: current }) => { if (active) setAdmin(current); })
      .catch(() => { if (active) onMissingSession(); });
    return () => { active = false; };
  }, [onMissingSession]);

  const update = useCallback((next) => setAdmin(next), []);

  return <AdminContext.Provider value={{ admin, setAdmin: update }}>{children}</AdminContext.Provider>;
}

export function useAdmin() {
  const value = useContext(AdminContext);
  if (!value) throw new Error('useAdmin precisa estar dentro de <AdminProvider>');
  return value;
}
